import { useEffect } from 'react';
import { isJourneyReport } from 'reporting-data/tsTypes/reportTypes';
import JourneyAnonVisitorsEditor from 'reporting-enablement/components/reportEditors/JourneyAnonVisitorsEditor';
import { useIsEnabledForReport } from 'reporting-enablement/components/reportEditors/JourneyAnonVisitorsEditor/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const JourneyAnonVisitorControl = ({
  report,
  updateContext
}) => {
  const isEnabled = useIsEnabledForReport(report.toJS());

  /*eslint-disable react-hooks/exhaustive-deps*/
  useEffect(() => {
    if (!isEnabled) {
      updateContext({
        includeAnonymousVisitors: false
      }, report);
    }
  }, [isEnabled]);
  /*eslint-disable react-hooks/exhaustive-deps*/

  return /*#__PURE__*/_jsx(JourneyAnonVisitorsEditor, {
    report: report,
    onChange: modifiedReport => {
      updateContext({
        includeAnonymousVisitors: modifiedReport.getIn(['journeyQuery', 'allowAnonymousVisitors']),
        contactObjectFiltering: modifiedReport.getIn(['journeyQuery', 'objectQuery', 'filtering'], null)
      }, report);
    }
  });
};
JourneyAnonVisitorControl.isUsableForReport = ({
  report
}) => {
  return isJourneyReport(report);
};
export default JourneyAnonVisitorControl;